import React from "react";
import { Col, Container, Row } from "react-bootstrap";
import { Link } from "gatsby";
import { StaticImage } from "gatsby-plugin-image";

function Tailoredlogistics() {
  return (
    <section className="tailored_logistics p-100">
      <Container>
        <Row>
          <Col
            xs={12}
            md={6}
            lg={5}
            xl={5}
            xxl={5}
            className="text-center order-2 order-md-1"
          >
            <StaticImage
              src="../../images/services-usa/logistics-app/tailored-logistics.webp"
              alt="TekRevol"
              layout="constrained"
              placeholder="blurred"
              formats={["webp"]}
              width={814}
              height={504}
            />
          </Col>
          <Col
            xs={12}
            md={6}
            lg={6}
            xl={6}
            xxl={6}
            className="order-1 order-md-2 offset-lg-1"
          >
            <h2>
              Design a Tailored <span>Logistics Management</span> App
            </h2>
            <p>
              Gain full control over your logistics with custom software
              designed for real-time fleet tracking, automated route
              optimization, and dispatch scheduling. Improve inventory
              management, integrate GPS tracking for precise delivery updates,
              and automate freight allocation. Reduce downtime, cut fuel costs,
              and streamline warehouse operations with a comprehensive solution
              that adapts to your logistics needs.
            </p>
            <Link
              to="/contact"
              className="border_btn dark_btn"
              aria-label="TekRevol Contact"
            >
              Discuss Your Logistics App Idea
            </Link>
          </Col>
        </Row>
      </Container>
    </section>
  );
}

export default Tailoredlogistics;
